module.exports = __webpack_public_path__ + "edacbfac7549cf695086fb1dc9070a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Pear.png
// module id = 781
// module chunks = 0